import styled from 'styled-components';
export const SwitchLabel = styled.label`
  position: relative;
  display: inline-block;
  width: 54px;
  height: 22px;
`;
export const SliderInput = styled.input`
  opacity: 0;
  width: 0;
  height: 0;

  &:checked + .slider {
    background-color: #6dd400;
  }

  &:focus + .slider {
    box-shadow: 0 0 1px #6dd400;
  }

  &:checked + .slider:before {
    transform: translateX(31px);
  }
`;
export const Slider = styled.span`
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #e02020;
  -webkit-transition: 0.4s;
  transition: 0.4s;
  border-radius: 34px;

  &:before {
    position: absolute;
    content: '';
    height: 18px;
    width: 18px;
    left: 2px;
    bottom: 2px;
    background-color: white;
    -webkit-transition: 0.4s;
    transition: 0.4s;
    border-radius: 50%;
  }
`;